import { render, staticRenderFns } from "./menu-add-or-update.vue?vue&type=template&id=6aae6e95&scoped=true&"
import script from "./menu-add-or-update.vue?vue&type=script&lang=js&"
export * from "./menu-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./menu-add-or-update.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./menu-add-or-update.vue?vue&type=style&index=1&id=6aae6e95&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aae6e95",
  null
  
)

export default component.exports